const Skills = (state = [], action = {}) => {
    switch (action.type) {
        case "SET_SKILLS_DATA":
            return action.payload;
        default:
            return state;
    }
};

export default Skills;
  